import { render, staticRenderFns } from "./PeiAdditionalQuestions.vue?vue&type=template&id=6771fa49&"
import script from "./PeiAdditionalQuestions.vue?vue&type=script&lang=js&"
export * from "./PeiAdditionalQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports